export default "__VITE_ASSET__BdACGUyS__"